export default "/_next/static/images/bullet-point-d206f6061722f16647ffa8d7909e6e20.svg";